import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import Card from '../../../../components/card';
import Alert from '../../../../components/alert';
import { getNotifications } from '../../../../reducers/notifications';

class DashboardAlerts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { profile, role, getNotifications } = this.props;
        getNotifications(role, profile);
    }

    notificationList() {
        const { notifications } = this.props;
        if (!notifications || notifications.length === 0) return null;

        const limitedNotifications = notifications.slice(0, 8);
        return <React.Fragment>{limitedNotifications.map((n, i) => <Alert key={n.id || i} notification={n} />)}</React.Fragment>;
    }

    render() {
        const content = this.notificationList();

        return (
            <Card
                title={<FormattedMessage {...messages.alerts} />}
                content={content}
                emptyMessage={
                    <div className="no-new-alerts">
                        <FormattedMessage id={'noAlerts'} defaultMessage={'No new alerts.'} />
                    </div>
                }
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        profile: state.identity.profile,
        notifications: (state.notifications.list || []).filter(n => n.status !== 'dismissed').sort((a, b) => b.priority.localeCompare(a.priority))
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getNotifications
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DashboardAlerts);



// WEBPACK FOOTER //
// ./src/pages/dashboard/components/alerts/index.jsx